export async function getCameraStreamByLabel( label ) {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    const videoDevices = devices.filter( device => device.kind === 'videoinput' )

    if ( videoDevices.length === 0 ) {
      throw new Error( "No video input devices found." )
    }

    let selectedDeviceId = null
    if ( label ) {
      const matchingDevice = videoDevices.find( device => device.label === label )
      if ( matchingDevice ) {
        selectedDeviceId = matchingDevice.deviceId
      }
      else {
        console.warn( `Camera with label "${ label }" not found. Using default camera if available.` )
      }
    }
    else {
      console.log( "No camera label provided, attempting to use default camera." )
    }

    const constraints = selectedDeviceId ? { video: { deviceId: selectedDeviceId } } : { video: true }

    const stream = await navigator.mediaDevices.getUserMedia( constraints )
    return {
      video: stream,
      videoSettings: stream.getVideoTracks()[0].getSettings()
    }
  }
  catch ( error ) {
    console.error( "Error getting camera stream:", error )
    throw error // Re-throw the error to be handled by the caller
  }
}
